import emailjs from '@emailjs/browser';

// EmailJS Configuration
export const emailConfig = {
  // Replace these with your actual EmailJS credentials
  SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'your_service_id',
  TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'your_template_id',
  PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'your_public_key',
};

// Initialize EmailJS
emailjs.init(emailConfig.PUBLIC_KEY);

// Send email function
export const sendContactEmail = async (formData) => {
  try {
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      company: formData.company || 'Not specified',
      service: formData.service,
      message: formData.message,
      to_email: 'your-email@gmail.com', // Replace with your Gmail address
    };

    const response = await emailjs.send(
      emailConfig.SERVICE_ID,
      emailConfig.TEMPLATE_ID,
      templateParams
    );

    return { success: true, response };
  } catch (error) {
    console.error('Email sending failed:', error);
    return { success: false, error };
  }
}; 